import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Dialog from "../../components/Dialog";
import InputTextArea from "../../components/InputTextArea";
import IModalProps from "../../model/ModalProps";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const { StyledModalTitle, StyledContainerButton } = DialogStyles;

interface IModalRequestJustificationEndTachProps extends IModalProps {
    onSubmit: (justification: string) => void;
}

function ModalRequestJustificationEndTach(
    props: IModalRequestJustificationEndTachProps
) {
    const [justification, setJustification] = useState("");

    const isFormValid = Boolean(justification.trim());

    useEffect(() => {
        setJustification("");
    }, [props.open]);

    return (
        <Dialog openModal={props.open} onHide={props.onClose} size="width-600">
            <StyledModalTitle style={{ marginBottom: 28 }}>
                Informe abaixo a justificativa
            </StyledModalTitle>
            <Row>
                <Col>
                    <InputTextArea
                        placeholder="Finalizado por motivos de..."
                        maxLength={500}
                        value={justification}
                        onChange={(event: any) =>
                            setJustification(event.target.value as string)
                        }
                        style={{ height: "95px" }}
                    />
                </Col>
            </Row>
            <StyledContainerButton>
                <BtnPrimary
                    disabled={!isFormValid}
                    onClick={() => props.onSubmit(justification)}
                >
                    Confirmar
                </BtnPrimary>
            </StyledContainerButton>
            <StyledContainerButton>
                <DefaultButtonLink onClick={props.onClose}>
                    Cancelar
                </DefaultButtonLink>
            </StyledContainerButton>
        </Dialog>
    );
}

export default ModalRequestJustificationEndTach;
